import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { uploadPhoto } from "../services/storageService";
import { convertPriceForUser } from "../utils/currencyUtils";

export function createGiftHandlers(ctx) {
  const {
    user, userProfile, lang, currentFamily,
    viewingMember, viewingWishlist,
    giftForm, members,
    setViewingWishlist, setViewingMember,
    setGiftForm, setScreen,
    setUploading, setUploadProgress,
    setAutoFilling,
    setPrevViewingMember, setPrevViewingWishlist,
    prevViewingMember, prevViewingWishlist,
    setCopyGiftModal, copyGiftModal,
    setCoopPanelData, setShowCoopPanel,
    setUserProfile,
    showToast, tr,
    copyTargetWishlistId,
  } = ctx;

  const saveGift = async function () {
    const wishlistId =
      viewingWishlist?.id ||
      (viewingMember?.isManaged ? viewingMember.wishlistId : null) ||
      (userProfile?.familyWishlists || {})[currentFamily?.id];

    if (!wishlistId) { showToast(tr("errorSaving")); return; }
    setUploading(true);
    setUploadProgress(0);

    try {
      let finalPhotoUrl = giftForm.photoUrl || "";
      if (giftForm.photoFile) finalPhotoUrl = await uploadPhoto(giftForm.photoFile, user.uid, setUploadProgress);

      const wSnap = await getDoc(doc(db, "wishlists", wishlistId));
      if (!wSnap.exists()) { showToast(tr("errorSaving")); setUploading(false); return; }

      let gifts = wSnap.data().gifts || [];
      if (giftForm.editId) {
        gifts = gifts.map((g) =>
  g.id === giftForm.editId
    ? {
        ...g,
        name: giftForm.name,
        link: giftForm.link,
        description: giftForm.description,
        price: giftForm.price || "",
        currency: giftForm.currency || "USD",
        photoUrl: finalPhotoUrl,
        cooperations: giftForm.cooperations || [],  // ← agrega esto
      }
    : g
);
        showToast(tr("giftUpdated"));
      } else {
        gifts = [...gifts, {
          id: Date.now().toString(),
          name: giftForm.name, link: giftForm.link, description: giftForm.description,
          price: giftForm.price || "", currency: giftForm.currency || "USD",
          photoUrl: finalPhotoUrl, purchased: false, purchasedBy: null,
        }];
        showToast(tr("giftAdded"));
      }
      await updateDoc(doc(db, "wishlists", wishlistId), {
        gifts,
        ownerName: userProfile?.name || viewingMember?.name || "",
        ownerColor: userProfile?.color || viewingMember?.color || "#9b59b6",
        ownerCountry: userProfile?.country || "",
      });

      setViewingWishlist((w) => (w ? { ...w, gifts } : w));
      setGiftForm({ name: "", link: "", description: "", price: "", currency: "USD", photoUrl: "", photoFile: null, editId: null });

      if (prevViewingMember) {
        setViewingMember(prevViewingMember);
        if (prevViewingMember.id !== user.uid) {
          setViewingWishlist(prevViewingWishlist);
        }
        setPrevViewingMember(null);
        setPrevViewingWishlist(null);
      }
      setScreen("profile");
    } catch (e) {
      showToast(tr("errorSaving"));
      console.error(e);
    }
    setUploading(false);
  };

 const editGift = function (gift) {
  setPrevViewingMember(viewingMember);
  setPrevViewingWishlist(viewingWishlist);
  setGiftForm({
    name: gift.name, link: gift.link, description: gift.description,
    price: gift.price || "", currency: gift.currency || "USD",
    photoUrl: gift.photoUrl, photoFile: null, editId: gift.id,
    cooperations: gift.cooperations || [],  // ← agrega esto
  });
  setScreen("add");
  setTimeout(() => { const p = document.querySelector(".pantalla"); if (p) p.scrollTop = 0; }, 30);
};

  const deleteGift = async function (id) {
  if (!window.confirm(tr("deleteConfirm"))) return;
  const wishlistId = viewingWishlist?.id;
  const wSnap = await getDoc(doc(db, "wishlists", wishlistId));
  const gifts = (wSnap.data().gifts || []).filter((g) => g.id !== id);
  await updateDoc(doc(db, "wishlists", wishlistId), { gifts });
  setViewingWishlist((w) => (w ? { ...w, gifts } : w));
  showToast(tr("giftRemoved"));
};

  const handleAutoFill = async function () {
    if (!giftForm.link) return;
    setAutoFilling(true);
    try {
      const response = await fetch("/api/autofill", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: giftForm.link }),
      });
      const parsed = await response.json();
      if (parsed.error) throw new Error(parsed.error);
      setGiftForm((f) => ({
        ...f,
        name: parsed.name || f.name,
        price: parsed.price ? String(parsed.price) : f.price,
        currency: parsed.currency || f.currency,
        photoUrl: parsed.imageUrl || f.photoUrl,
      }));
      showToast(lang === "es" ? "¡Datos cargados!" : "Data loaded!");
    } catch (e) {
      console.error("AutoFill error:", e);
      showToast(lang === "es" ? "No se pudo obtener la info" : "Could not fetch info");
    }
    setAutoFilling(false);
  };

  const copyGiftToMyList = function (gift, currentMember, currentWishlist) {
    setCopyGiftModal({
      gift,
      fromMember: currentMember || viewingMember,
      fromWishlist: currentWishlist || viewingWishlist,
    });
  };

  const confirmCopyGift = function () {
  if (!copyGiftModal) return;
  const { gift, fromMember, fromWishlist } = copyGiftModal;
  setPrevViewingMember(fromMember);
  setPrevViewingWishlist(fromWishlist);

  const myCurrency = userProfile?.currency || "USD";
  let prefillPrice = gift.price || "";
  let prefillCurrency = myCurrency;

  if (gift.price && parseFloat(gift.price) > 0) {
    const converted = convertPriceForUser(gift.price, gift.currency || "USD", ctx.userProfile, ctx.exchangeRates);
    if (converted) {
      prefillPrice = converted.val.toFixed(2);
      prefillCurrency = myCurrency;
    }
  }

  setGiftForm({
    name: gift.name || "",
    link: gift.link || "",
    description: gift.description || "",
    price: prefillPrice,
    currency: prefillCurrency,
    photoUrl: gift.photoUrl || "",
    photoFile: null,
    editId: null,
  });

  const familyWishlists = userProfile?.familyWishlists || {};
const myWishlistId = copyTargetWishlistId
  || (currentFamily?.id && familyWishlists[currentFamily.id])
  || Object.values(familyWishlists)[0]
  || (userProfile?.wishlists || [])[0];

  const myMember = members.find((m) => m.id === user.uid);
  if (myMember) {
    setViewingMember(myMember);
    setViewingWishlist({ id: myWishlistId, gifts: myMember.gifts || [] });
  } else {
    setViewingMember({ id: user.uid, ...userProfile });
    setViewingWishlist({ id: myWishlistId, gifts: [] });
  }

  setCopyGiftModal(null);
  setPrevViewingMember(null);
  setPrevViewingWishlist(null);
  setScreen("add");
};

  const commitGift = async function (wishlistId, giftId, gift, isShared) {
    if (!user) { setScreen("login"); return; }
    const wSnap = await getDoc(doc(db, "wishlists", wishlistId));
    const gifts = (wSnap.data().gifts || []).map((g) =>
      g.id !== giftId ? g : { ...g, committedBy: user.uid }
    );
    await updateDoc(doc(db, "wishlists", wishlistId), { gifts });
    const userSnap = await getDoc(doc(db, "users", user.uid));
    const existing = (userSnap.data().committedGifts || []).filter((g) => g.giftId !== giftId);
    existing.push({
      wishlistId, giftId,
      price: gift.price || "0",
      currency: gift.currency || userProfile?.currency || "USD",
      name: gift.name || "",
      ownerName: viewingMember?.name || "",
      photoUrl: gift.photoUrl || "",
      purchased: false,
      committedAt: Date.now(),
      familyId: currentFamily?.id || null,
    });
    

    await updateDoc(doc(db, "users", user.uid), { committedGifts: existing });
    setUserProfile((p) => ({ ...p, committedGifts: existing }));
    if (isShared) ctx.setSharedWishlist?.((w) => (w ? { ...w, gifts } : w));
    else setViewingWishlist((w) => (w ? { ...w, gifts } : w));
    showToast(lang === "es" ? "¡Agregado a tu presupuesto!" : lang === "fi" ? "Lisätty budjettiisi!" : "Added to your budget!");
  };

  const togglePurchased = (wishlistId, giftId, gift, isShared) =>
    commitGift(wishlistId, giftId, gift, isShared);

  const markAsPurchased = async function (entry) {
    if (!user) return;
    const wSnap = await getDoc(doc(db, "wishlists", entry.wishlistId));
    if (wSnap.exists()) {
      const gifts = (wSnap.data().gifts || []).map((g) =>
        g.id !== entry.giftId ? g : { ...g, purchased: true, purchasedBy: user.uid }
      );
      await updateDoc(doc(db, "wishlists", entry.wishlistId), { gifts });
      setViewingWishlist((wishlist) =>
        wishlist?.id === entry.wishlistId ? { ...wishlist, gifts } : wishlist
      );
    }
    const userSnap = await getDoc(doc(db, "users", user.uid));
    const updated = (userSnap.data().committedGifts || []).map((g) =>
      g.wishlistId !== entry.wishlistId || g.giftId !== entry.giftId
        ? g
        : { ...g, purchased: true }
    );
    await updateDoc(doc(db, "users", user.uid), { committedGifts: updated });
    setUserProfile((p) => ({ ...p, committedGifts: updated }));
    showToast("✅ " + tr("markedPurchased"));
  };

  const markAsNotPurchased = async function (entry) {
    if (!user) return;
    const matchesGift = (gift) =>
      gift.wishlistId === entry.wishlistId && gift.giftId === entry.giftId;
    const wSnap = await getDoc(doc(db, "wishlists", entry.wishlistId));
    if (wSnap.exists()) {
      const gifts = (wSnap.data().gifts || []).map((gift) => {
        if (gift.id !== entry.giftId) return gift;
        const updatedGift = { ...gift, purchased: false };
        delete updatedGift.purchasedBy;
        return updatedGift;
      });
      await updateDoc(doc(db, "wishlists", entry.wishlistId), { gifts });
      setViewingWishlist((wishlist) =>
        wishlist?.id === entry.wishlistId ? { ...wishlist, gifts } : wishlist
      );
    }

    const userSnap = await getDoc(doc(db, "users", user.uid));
    const updated = (userSnap.data().committedGifts || []).map((gift) =>
      matchesGift(gift) ? { ...gift, purchased: false } : gift
    );
    await updateDoc(doc(db, "users", user.uid), { committedGifts: updated });
    setUserProfile((profile) => ({ ...profile, committedGifts: updated }));
    showToast(tr("markedNotPurchased"));
  };

  const uncommitGift = async function (entry) {
    if (!user) return;
    const wSnap = await getDoc(doc(db, "wishlists", entry.wishlistId));
    if (wSnap.exists()) {
      const gifts = (wSnap.data().gifts || []).map((g) => {
        if (g.id !== entry.giftId) return g;
        const copy = { ...g };
        delete copy.committedBy;
        copy.purchased = false; copy.purchasedBy = null;
        return copy;
      });
      await updateDoc(doc(db, "wishlists", entry.wishlistId), { gifts });
    }
    const userSnap = await getDoc(doc(db, "users", user.uid));
    const updated = (userSnap.data().committedGifts || []).filter((g) => g.giftId !== entry.giftId);
    await updateDoc(doc(db, "users", user.uid), { committedGifts: updated });
    setUserProfile((p) => ({ ...p, committedGifts: updated }));
    showToast(tr("markedAvailable"));
  };

  const cooperateGift = async function (wishlistId, giftId, amount, method) {
  if (!user || !amount || isNaN(parseFloat(amount))) return;
  const val = parseFloat(amount);
  const wSnap = await getDoc(doc(db, "wishlists", wishlistId));
  if (!wSnap.exists()) return;
  const fid = currentFamily?.id;
  const displayName = (fid && userProfile?.groupNicknames?.[fid])
    ? userProfile.groupNicknames[fid]
    : (userProfile?.name || "");
  const gifts = (wSnap.data().gifts || []).map((g) => {
    if (g.id !== giftId) return g;
    const cooperations = g.cooperations || [];
    const updated = [...cooperations, {
      uid: user.uid,
      amount: val,
      name: displayName,
      at: Date.now(),
      ...(method ? { method } : {})
    }];
    return { ...g, cooperations: updated };
  });
  await updateDoc(doc(db, "wishlists", wishlistId), { gifts });
  setViewingWishlist((wl) => (wl ? { ...wl, gifts } : wl));
  showToast(lang === "es" ? "💸 ¡Cooperación registrada!" : "💸 Contribution registered!");
};

  const loadCoopPanel = async function () {
    if (!user || !userProfile) return;
    setCoopPanelData(null);
    setShowCoopPanel(true);
    const wishlistIds = userProfile.wishlists || [];
    if (wishlistIds.length === 0) { setCoopPanelData([]); return; }
    const snaps = await Promise.all(wishlistIds.map((wid) => getDoc(doc(db, "wishlists", wid))));
    const entries = [];
    snaps.forEach((snap) => {
      if (!snap.exists()) return;
      const data = snap.data();
      (data.gifts || []).forEach((g) => {
        (g.cooperations || []).forEach((c) => {
          entries.push({
            wishlistId: snap.id,
            giftId: g.id,
            giftName: g.name || "Regalo",
            giftPhoto: g.photoUrl || null,
            price: g.price || null,
            uid: c.uid,
            name: c.name || "?",
            amount: c.amount,
            at: c.at || 0,
            method: c.method || null, 
          });
        });
      });
    });
    entries.sort((a, b) => b.at - a.at);
const confirmedKeys = ctx.userProfile?.confirmedCoopKeys || [];
const filtered = entries.filter(function(entry) {
  const coopKey = (entry.wishlistId || "") + "_" + (entry.giftId || "") + "_" + (entry.uid || entry.name || "") + "_" + (entry.at || "");
  return !confirmedKeys.includes(coopKey);
});
setCoopPanelData(filtered);
  };

  // FIX: deleteCoopEntry también actualiza el estado local de viewingWishlist
  // para que la barra de progreso desaparezca inmediatamente al rechazar
  const deleteCoopEntry = async function (entry) {
  const wSnap = await getDoc(doc(db, "wishlists", entry.wishlistId));
    if (!wSnap.exists()) return;
    const gifts = (wSnap.data().gifts || []).map((g) => {
      if (g.id !== entry.giftId) return g;
      return { ...g, cooperations: (g.cooperations || []).filter((c) => {
  if (entry.at && c.at) return !(c.uid === entry.uid && c.at === entry.at);
  return c.uid !== entry.uid;
}) };
    });
    await updateDoc(doc(db, "wishlists", entry.wishlistId), { gifts });
    // Actualizar panel de coops (quita la entrada)
    setCoopPanelData((prev) => (prev || []).filter(
      (e) => !(e.wishlistId === entry.wishlistId && e.giftId === entry.giftId && e.uid === entry.uid && e.at === entry.at)
    ));
    // FIX: también actualizar viewingWishlist para que la barra de progreso se resetee
    setViewingWishlist((wl) => {
      if (!wl || wl.id !== entry.wishlistId) return wl;
      return { ...wl, gifts };
    });
    showToast(lang === "es" ? "❌ Cooperación rechazada" : "❌ Contribution rejected");
  };

  return {
    saveGift, editGift, deleteGift, handleAutoFill,
    copyGiftToMyList, confirmCopyGift,
    commitGift, togglePurchased, markAsPurchased, markAsNotPurchased, uncommitGift,
    cooperateGift, loadCoopPanel, deleteCoopEntry,
  };
}

export default createGiftHandlers;
